import { render, staticRenderFns } from "./commentsList.vue?vue&type=template&id=1142888c&scoped=true"
import script from "./commentsList.vue?vue&type=script&lang=js"
export * from "./commentsList.vue?vue&type=script&lang=js"
import style0 from "./commentsList.vue?vue&type=style&index=0&id=1142888c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142888c",
  null
  
)

export default component.exports